import { Redirect } from 'expo-router';

import { IS_PRODUCTION } from '../../../config/FruitfulEnvironment';
import SimulateICTWithdrawal from '../../../investment/components/ict-simulation/SimulateICTWithdrawal';

const SimulateICTWithdrawalScreen = () => {
    if (IS_PRODUCTION) {
        return <Redirect href="/home/investment" />;
    }

    return <SimulateICTWithdrawal />;
};

export default SimulateICTWithdrawalScreen;
